export type FirestoreAppSource = 'mobile-app' | 'admin-panel';
export type FirestoreRepo = 'OverhearExpo-Ignite10' | 'OVERHEAR-Admin-Panel';

export interface FirestoreReadContext {
  readTag: string;
  appSource?: FirestoreAppSource;
  repo?: FirestoreRepo;
  extra?: Record<string, string | number | boolean | undefined>;
}

interface FirestoreReadTelemetryPayload extends FirestoreReadContext {
  kind: 'getDocs' | 'onSnapshot';
  collectionName: string;
  docCount: number;
  durationMs?: number;
  fromCache?: boolean;
  hasPendingWrites?: boolean;
}

function shouldSample(): boolean {
  if (import.meta.env.DEV) return true;
  return Math.random() < 0.1;
}

export function emitFirestoreRead(payload: FirestoreReadTelemetryPayload): void {
  if (!shouldSample()) return;

  const event = {
    event: 'firestore_read',
    appSource: payload.appSource ?? 'admin-panel',
    repo: payload.repo ?? 'OVERHEAR-Admin-Panel',
    readTag: payload.readTag,
    kind: payload.kind,
    collectionName: payload.collectionName,
    docCount: payload.docCount,
    durationMs: payload.durationMs,
    fromCache: payload.fromCache,
    hasPendingWrites: payload.hasPendingWrites,
    ...payload.extra,
  };

  if (import.meta.env.DEV) {
    console.info('[firestore-read]', JSON.stringify(event));
    return;
  }

  console.warn('[firestore-read]', event);
}
